<template>
    <v-container>
        <v-row>
            <v-col cols="12" v-if="!loadingSearch">
                <v-card class="do-not-print">
                    <v-col cols="12">
                        <v-row >
                            <v-col cols="12">
                                <h2 class="text-center">Husbandry Report</h2>
                            </v-col>
                        </v-row>

                        <v-container fluid>
                            <v-form @submit.prevent ref="searchFOrm" v-model="searchHusbandryValid">
                                <v-row>
                                    <v-col cols="12">
                                        <h3>Search within</h3>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-menu
                                            ref="searchRangeMinDateMenu"
                                            v-model="searchRangeMinDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="displayRangeStartDate"
                                                    label="Start Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker 
                                                v-model="search.searchRangeMinDate"
                                                scrollable
                                                @input="searchRangeMinDateMenu = false"
                                                :title-date-format="datePickerFormat"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-menu
                                            ref="searchRangeMaxDateMenu"
                                            v-model="searchRangeMaxDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="displayRangeEndDate"
                                                    label="End Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="search.searchRangeMaxDate"
                                                scrollable
                                                @input="searchRangeMaxDateMenu = false"
                                                :title-date-format="datePickerFormat"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12">
                                        <h3>Filters</h3>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-text-field
                                            clearable
                                            counter="20"
                                            maxlength="20"
                                            v-model="search.specimenDisplayID"
                                            label="Specimen ID"
                                            @keyup.native="checkEnterKeyPerformSearch">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-select
                                            :items="species"
                                            item-text="SpeciesFullName"
                                            item-value="SpeciesID"
                                            v-model="search.speciesID"
                                            label="Species"
                                            clearable
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-select
                                            :items="suppliers"
                                            item-text="SupplierName"
                                            item-value="SupplierID"
                                            v-model="search.supplierID"
                                            label="Supplier"
                                            clearable
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-select
                                            :items="genders"
                                            item-text="name"
                                            item-value="value"
                                            v-model="search.gender"
                                            label="Gender"
                                            clearable
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="6">
                                        <v-select
                                            :items="logTypes"
                                            item-text="name"
                                            item-value="value"
                                            v-model="search.logTypes"
                                            label="Log Type"
                                            multiple
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-menu
                                            ref="searchArrivalMinDateMenu"
                                            v-model="searchArrivalMinDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="displayArrivalStartDate"
                                                    label="Arrival Start Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker 
                                                v-model="search.searchArrivalMinDate"
                                                scrollable
                                                @input="searchArrivalMinDateMenu = false"
                                                :title-date-format="datePickerFormat"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-menu
                                            ref="searchArrivalMaxDateMenu"
                                            v-model="searchArrivalMaxDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="displayArrivalEndDate"
                                                    label="Arrival End Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="search.searchArrivalMaxDate"
                                                scrollable
                                                @input="searchArrivalMaxDateMenu = false"
                                                :title-date-format="datePickerFormat"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="9">
                                        <v-btn block color="primary" :disabled="!searchHusbandryValid" @click="performSearch" :loading="searching">Search</v-btn>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-btn block color="secondary" :disabled="!searchHusbandryValid" @click="print" :loading="searching">Print</v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-col>
                </v-card>
                <v-card>
                    <v-row >
                        <v-col cols="12" >
                            <DailyHusbandryHistory ref="historyLog" :displayDelete="false" :displaySpecimenID="true" :displayLocationWeight="true" :searchCriteria="searchActual"></DailyHusbandryHistory>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment';
import util from '@/helpers/util';
import constants from 'comunet-btg-utah-repository-shared/constants';
import DailyHusbandryHistory from "@/components/specimens/DailyHusbandryHistory";
import validationRules from "../../helpers/validationrules";


export default {
    components: {
        DailyHusbandryHistory
    },
    data() {
        return {
            rules: validationRules.rules,
            searchArrivalMinDateMenu: false,
            searchArrivalMaxDateMenu: false,
            searchRangeMinDateMenu: false,
            searchRangeMaxDateMenu: false,
            searchHusbandryValid: false,
            search: {
                searchArrivalMinDate: "",
                searchArrivalMaxDate: "",
                searchRangeMinDate: "",
                searchRangeMaxDate: "",
                specimenDisplayID: "",
                speciesID: "",
                supplierID: "",
                gender: "",
                logTypes: ["dh", "mo","co","do"]
            },
            searchActual: {},
            logTypes: [
                {
                    name: "Daily Husbandry",
                    value: "dh"
                },
                {
                    name: "Medical Observation",
                    value: "mo"
                },
                {
                    name: "Controlled Occurrence",
                    value: "co"
                },
                {
                    name: "Dangerous Occurrence",
                    value: "do"
                }
            ]
        }
    },
    computed: {
        displayArrivalStartDate: {
            get: function() {
                if (this.search && this.search.searchArrivalMinDate) {
                    return moment.utc(this.search.searchArrivalMinDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchArrivalMinDate = newValue;
            }
        },
        displayArrivalEndDate: {
            get: function() {
                if (this.search && this.search.searchArrivalMaxDate) {
                    return moment.utc(this.search.searchArrivalMaxDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchArrivalMaxDate = newValue;
            }
        },
        displayRangeStartDate: {
            get: function() {
                if (this.search && this.search.searchRangeMinDate) {
                    return moment.utc(this.search.searchRangeMinDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchRangeMinDate = newValue;
            }
        },
        displayRangeEndDate: {
            get: function() {
                if (this.search && this.search.searchRangeMaxDate) {
                    return moment.utc(this.search.searchRangeMaxDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchRangeMaxDate = newValue;
            }
        },
        loadingSearch() {
            return this.$store.state.speciesStore.loading
                || this.$store.state.supplierStore.loading;
        },
        searching() {
            // Note that this seems weird, as we are assuming that this is the same property used by the child,
            // however you can't have references in here so?
            return this.$store.state.dailyHusbandryStore.historyLoading;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesName"));
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active && s.IsSpecimenSupplier).sort(util.sortByField("SupplierName"));
        },
        genders() {
            return constants.GENDERS;
        }
    },
    methods: {
        checkEnterKeyPerformSearch(event){
            if (event.keyCode === 13){
                this.performSearch();
            }
        },
        datePickerFormat(date) {
            return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
        },
        ruleMaxDateRange(){
            if (moment(this.search.searchRangeMaxDate).diff(moment(this.search.searchRangeMinDate), 'days') <= 90){
                return true;
            } else {
                return "Date range cannot exceed 90 days";
            }
        },
        performSearch() {
            this.searchActual = {
                ...this.search
            };

            /**
             * In the sub component this data is passed to, there is a watcher on this data - passing in the time
             * ensures that the data watched has definitely changed, so we always trigger a search to the server
             * again when pressing the search button.
             * 
             * Without this line, then the watcher will only trigger the search to the server again when the
             * search criteria actually change. For this page we want the user to be able to update the search
             * data by clicking the button, so we force it.
             */
            this.searchActual.SearchTime = moment();
        },
        print() {
            window.print();
        }
    },
    created() {
        this.$store.dispatch("supplierStore/loadSuppliers");
        this.$store.dispatch("speciesStore/loadSpecies");

        this.search.searchRangeMinDate = moment().startOf('day').add(-90, 'days').format("YYYY-MM-DD");
        this.search.searchRangeMaxDate = moment().startOf('day').format("YYYY-MM-DD");

        this.searchActual = {
            ...this.search
        };
    }
}
</script>

<style>
</style>